import { appApi } from '../app/appApiQueries'
import { selectApp } from '../app/root'
import { useAppSelector } from '../hooks'
import ProfileIcon from '../icons/ProfileIcon'
import { Avatar } from '@zoom/react-ui'

function ProfilePic() {
  const app = useAppSelector(selectApp)!
  const { avatar } = appApi.endpoints.getUserAvatar.useQueryState(app, {
    selectFromResult: (result) => ({ avatar: result?.data?.avatar }),
  })
  const profilePic =
    app === 'Google' ? avatar : `data:image/png;base64,${avatar}`

  return (
    <>
      {avatar ? (
        <Avatar
          size='medium'
          src={profilePic}
        />
      ) : (
        <ProfileIcon />
      )}
    </>
  )
}

export default ProfilePic
